package services.http

import it.neckar.logging.Logger
import it.neckar.logging.LoggerFactory
import kotlinx.coroutines.*
import services.auth.http.FetchUsersAndCompaniesResponse
import services.storage.LoadEssentialsResponse
import services.storage.LoadedEssentials
import services.storage.http.FetchStaticPriceListResponse

/**
 * Supports loading of the essentials
 */
class EssentialsClientService(
  val authenticationService: AuthenticationClientService,
  val projectQueryService: ProjectQueryClientService,
) {
  /**
   * Loads the essentials
   */
  suspend fun loadEssentials(): LoadEssentialsResponse {
    logger.debug("Loading essentials")

    return withContext(Dispatchers.Default) {
      val usersAndCompaniesDeferred = async { authenticationService.fetchUsersAndCompanies() }
      val staticPriceListDeferred = async { projectQueryService.fetchStaticPriceList() }

      val usersAndCompaniesResult = usersAndCompaniesDeferred.await()
      val fetchStaticPriceListResponse = staticPriceListDeferred.await()

      val usersAndCompanies = when (usersAndCompaniesResult) {
        is FetchUsersAndCompaniesResponse.Good -> usersAndCompaniesResult.data
        is FetchUsersAndCompaniesResponse.Failed -> return@withContext LoadEssentialsResponse.bad()
      }

      when (fetchStaticPriceListResponse) {
        is FetchStaticPriceListResponse.Good -> {

          val fetchStaticPriceListInformation = fetchStaticPriceListResponse.data

          LoadEssentialsResponse.good(
            LoadedEssentials(
              usersAndCompanies = usersAndCompanies,
              availableProducts = fetchStaticPriceListInformation.availableProducts,
              productResolver = fetchStaticPriceListInformation.productResolver,
              priceList = fetchStaticPriceListInformation.priceList,
            )
          )
        }

        FetchStaticPriceListResponse.Failed -> return@withContext LoadEssentialsResponse.bad()
      }
    }
  }

  companion object {
    private val logger: Logger = LoggerFactory.getLogger("services.http.EssentialsClientService")
  }
}
